import { FC } from 'react';

import TableSingleApplication from '../../../components/table/recruiting/tableApplicationSingle';

import styles from './singleApplicationForm.module.scss';

const SingleApplicationForm: FC = () => {
	return (
		<div className={styles.vacancyCreateWrapper}>
			<TableSingleApplication />
		</div>
	);
};

export default SingleApplicationForm;
